import { render, staticRenderFns } from "./OuvidorManifestacao.vue?vue&type=template&id=3a3ae5d6&"
import script from "./OuvidorManifestacao.vue?vue&type=script&lang=js&"
export * from "./OuvidorManifestacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports